<!-- El FRC firmado a mano. Sin contenedor propio (host en display:
     contents): los botones caen en la fila de botones de quien lo usa.
     Se ofrece subir con firma en papel o, desde el 15/10/2026, a quien
     gestiona aunque no la haya (ofreceSubir). -->
<ng-container *ngIf="id != null && (haySubido || ofreceSubir)">

  <!-- Con texto, como el botón del FRC de al lado: «boton» es el redondo
       de las tarjetas (app-form-btn); «mini», el chico de las bandejas y
       los detalles (sus medidas las ajusta cada pantalla con --frc-*). -->
  <ng-container *ngIf="variante !== 'icono'; else comoIcono">
    <button type="button" class="frc-firmado frc-firmado--listo" [ngClass]="claseBoton"
            *ngIf="haySubido"
            [disabled]="abriendo"
            [matTooltip]="detalle"
            (click)="ver()">
      <span class="material-icons" aria-hidden="true">{{ abriendo ? 'hourglass_top' : 'task' }}</span>
      {{ etiquetaVer }}
    </button>
    <button type="button" class="frc-firmado" [ngClass]="claseBoton"
            [class.frc-firmado--falta]="!haySubido && enPapel"
            *ngIf="ofreceSubir"
            [disabled]="subiendo"
            [matTooltip]="textoSubir"
            (click)="elegir()">
      <span class="material-icons" aria-hidden="true">{{ subiendo ? 'hourglass_top' : 'upload_file' }}</span>
      {{ etiquetaSubir }}
    </button>
  </ng-container>

  <!-- En las acciones de una tabla: solo íconos, como todo el estándar.
       Ver (verde) si ya está; subir (ámbar) si falta el papel, o subir otro. -->
  <ng-template #comoIcono>
    <button type="button" class="table-page__action-btn frc-firmado frc-firmado--listo"
            *ngIf="haySubido"
            [disabled]="abriendo"
            [matTooltip]="detalle"
            [attr.aria-label]="'Ver el ' + que"
            (click)="ver()">
      <span class="material-icons" aria-hidden="true">{{ abriendo ? 'hourglass_top' : 'task' }}</span>
    </button>
    <button type="button" class="table-page__action-btn frc-firmado"
            [class.frc-firmado--falta]="!haySubido && enPapel"
            *ngIf="ofreceSubir"
            [disabled]="subiendo"
            [matTooltip]="textoSubir"
            [attr.aria-label]="ariaSubir"
            (click)="elegir()">
      <span class="material-icons" aria-hidden="true">{{ subiendo ? 'hourglass_top' : 'upload_file' }}</span>
    </button>
  </ng-template>

  <!-- Solo donde se puede subir: donde solo se ve, no hay ni el campo. -->
  <input #archivo type="file" class="frc-firmado__input"
         *ngIf="ofreceSubir"
         accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
         tabindex="-1" aria-hidden="true" [attr.aria-label]="'Subir el ' + doc + ' firmado'"
         (change)="elegido($event)">
</ng-container>
